export enum CalculatorVariant {
    Default = 'default',
    C2C = 'c2c'
}